/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Task_Management_LabelInputs */

const en_home_task_management_label = /** @type {(inputs: Home_Task_Management_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team updates`)
};

const lv_home_task_management_label = /** @type {(inputs: Home_Task_Management_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komandas kopsavilkumi`)
};

/**
* | output |
* | --- |
* | "Team updates" |
*
* @param {Home_Task_Management_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const home_task_management_label = /** @type {((inputs?: Home_Task_Management_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Task_Management_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_home_task_management_label(inputs)
	return en_home_task_management_label(inputs)
});